module.exports = __webpack_public_path__ + "img/logo.f4e2376c.png";